<template>
    <div class="">
        <div class="container">
            <el-tabs v-model="message" @tab-click="changeStyle()">
                <el-tab-pane label="家具列表" name="first">
                    <template v-if="message === 'first'">
                        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList('search')">
                            <el-form-item label="品牌">
                                <el-input v-model="dataForm.title" placeholder="请输入品牌" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="风格类型">
                                <el-select v-model="dataForm.style" clearable placeholder="请选择">
                                    <el-option
                                            v-for="item in styleList"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button @click="getDataList('search')" icon="el-icon-search">查询</el-button>
                                <el-button type="primary" @click="addOrUpdateHandle()"
                                           v-if="isAuth('means-add')">新增
                                </el-button>
                                <el-button type="danger" @click="deleteHandle()"
                                           v-if="isAuth('means-delete')"
                                           :disabled="dataListSelections.length <= 0">批量删除
                                </el-button>
                            </el-form-item>
                        </el-form>
                        <el-table
                                :data="dataList"
                                border
                                v-loading="dataListLoading"
                                @selection-change="selectionChangeHandle"
                                style="width: 100%;">
                            <el-table-column
                                    type="selection"
                                    header-align="center"
                                    align="center"
                                    width="50">
                            </el-table-column>
                            <el-table-column
                                    prop="id"
                                    header-align="center"
                                    align="center"
                                    width="80"
                                    label="编号">
                            </el-table-column>
                            <el-table-column
                                    prop="title"
                                    header-align="center"
                                    align="center"
                                    :show-overflow-tooltip="true"
                                    label="品牌">
                            </el-table-column>
                            <el-table-column
                                    prop="style"
                                    header-align="center"
                                    align="center"
                                    :show-overflow-tooltip="true"
                                    label="风格类型">
                            </el-table-column>
                            <el-table-column
                                    prop="file"
                                    header-align="center"
                                    align="left"
                                    :show-overflow-tooltip="true"
                                    label="文件">
                                <template slot-scope="scope">
                                    <el-button type="text" icon="el-icon-view" size="small"
                                               @click="lookHandle(scope.row.file,scope.row.filePath)">预览
                                    </el-button>
                                    <span style="margin-left: 10px;">{{scope.row.file}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="wayCooper"
                                    header-align="center"
                                    align="center"
                                    :show-overflow-tooltip="true"
                                    label="合作方式">
                                <template slot-scope="scope">
                                    <el-tag v-if="scope.row.wayCooper === 1">工厂合作</el-tag>
                                    <el-tag v-if="scope.row.wayCooper === 2" type="success">经销商合作</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="creationDate"
                                    header-align="center"
                                    align="center"
                                    :show-overflow-tooltip="true"
                                    label="创建时间">
                            </el-table-column>
                            <el-table-column
                                    fixed="right"
                                    header-align="center"
                                    align="center"
                                    width="150"
                                    label="操作">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="mini"
                                               v-if="isAuth('means-edit')"
                                               @click="addOrUpdateHandle(scope.row.id)">编辑
                                    </el-button>
                                    <el-button type="danger" size="mini"
                                               v-if="isAuth('means-delete')"
                                               @click="deleteHandle(scope.row.id)">删除
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                                @size-change="sizeChangeHandle"
                                @current-change="currentChangeHandle"
                                :current-page="pageIndex"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="pageSize"
                                :total="totalPage"
                                layout="total, sizes, prev, pager, next, jumper">
                        </el-pagination>
                        <means-add-or-update v-if="addOrUpdateVisible" ref="means"
                                             @getDataList="getDataList()" :type="message"></means-add-or-update>
                    </template>
                </el-tab-pane>
                <el-tab-pane label="饰品列表" name="second">
                    <template v-if="message === 'second'">
                        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList('search')">
                            <el-form-item label="品牌">
                                <el-input v-model="dataForm.title" placeholder="请输入品牌" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="风格类型">
                                <el-select v-model="dataForm.style" clearable placeholder="请选择">
                                    <el-option
                                            v-for="item in styleList"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button @click="getDataList('search')" icon="el-icon-search">查询</el-button>
                                <el-button type="primary" @click="addOrUpdateHandle()"
                                           v-if="isAuth('means-add')">新增
                                </el-button>
                                <el-button type="danger" @click="deleteHandle()"
                                           v-if="isAuth('means-delete')"
                                           :disabled="dataListSelections.length <= 0">批量删除
                                </el-button>
                            </el-form-item>
                        </el-form>
                        <el-table
                                :data="dataList"
                                border
                                v-loading="dataListLoading"
                                @selection-change="selectionChangeHandle"
                                style="width: 100%;">
                            <el-table-column
                                    type="selection"
                                    header-align="center"
                                    align="center"
                                    width="50">
                            </el-table-column>
                            <el-table-column
                                    prop="id"
                                    header-align="center"
                                    align="center"
                                    width="80"
                                    label="编号">
                            </el-table-column>
                            <el-table-column
                                    prop="title"
                                    header-align="center"
                                    align="center"
                                    :show-overflow-tooltip="true"
                                    label="品牌">
                            </el-table-column>
                            <el-table-column
                                    prop="style"
                                    header-align="center"
                                    align="center"
                                    :show-overflow-tooltip="true"
                                    label="风格类型">
                            </el-table-column>
                            <el-table-column
                                    prop="file"
                                    header-align="center"
                                    align="left"
                                    :show-overflow-tooltip="true"
                                    label="文件">
                                <template slot-scope="scope">
                                    <el-button type="text" icon="el-icon-view" size="small"
                                               @click="lookHandle(scope.row.file,scope.row.filePath)">预览
                                    </el-button>
                                    <span style="margin-left: 10px;">{{scope.row.file}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="wayCooper"
                                    header-align="center"
                                    align="center"
                                    :show-overflow-tooltip="true"
                                    label="合作方式">
                                <template slot-scope="scope">
                                    <el-tag v-if="scope.row.wayCooper === 1">工厂合作</el-tag>
                                    <el-tag v-if="scope.row.wayCooper === 2" type="success">经销商合作</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="creationDate"
                                    header-align="center"
                                    align="center"
                                    :show-overflow-tooltip="true"
                                    label="创建时间">
                            </el-table-column>
                            <el-table-column
                                    fixed="right"
                                    header-align="center"
                                    align="center"
                                    width="150"
                                    label="操作">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="mini"
                                               v-if="isAuth('means-edit')"
                                               @click="addOrUpdateHandle(scope.row.id)">编辑
                                    </el-button>
                                    <el-button type="danger" size="mini"
                                               v-if="isAuth('means-delete')"
                                               @click="deleteHandle(scope.row.id)">删除
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                                @size-change="sizeChangeHandle"
                                @current-change="currentChangeHandle"
                                :current-page="pageIndex"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="pageSize"
                                :total="totalPage"
                                layout="total, sizes, prev, pager, next, jumper">
                        </el-pagination>
                        <means-add-or-update v-if="addOrUpdateVisible" ref="means"
                                             @getDataList="getDataList()"
                                             :type="message"></means-add-or-update>
                    </template>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import MeansAddOrUpdate from "./means-add-or-update";
    import {Means} from "../../api/means";
    import {Upload} from "../../api/upload";

    export default {
        name: 'means',
        data() {
            return {
                message: 'first',
                showHeader: false,
                dataForm: {
                    title: '',
                    style: ''
                },
                styleList: [
                    {value: '现代', label: '现代'},
                    {value: '北欧', label: '北欧'},
                    {value: '轻奢', label: '轻奢'},
                    {value: '美式', label: '美式'},
                    {value: '新中式', label: '新中式'},
                    {value: '新古典', label: '新古典'},
                    {value: '其他', label: '其他'},
                ],
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                addOrUpdateVisible: false
            }
        },
        components: {
            MeansAddOrUpdate
        },
        created() {
            this.getDataList();
        },
        activated() {
            this.getDataList();
        },
        methods: {
            changeStyle() {
                //console.log(this.message);
                let message = this.message;
                if (message === 'first') {
                    this.styleList = [
                        {value: '现代', label: '现代'},
                        {value: '北欧', label: '北欧'},
                        {value: '轻奢', label: '轻奢'},
                        {value: '美式', label: '美式'},
                        {value: '新中式', label: '新中式'},
                        {value: '新古典', label: '新古典'},
                        {value: '其他', label: '其他'},
                    ];
                    this.dataForm.title = '';
                    this.dataForm.style = '';
                } else if (message === 'second') {
                    this.styleList = [
                        {value: '地毯', label: '地毯'},
                        {value: '挂画', label: '挂画'}
                    ];
                    this.dataForm.title = '';
                    this.dataForm.style = '';
                }
                this.getDataList();
            },
            //预览
            lookHandle(file, filePath) {
                if (file === null || file === '') {
                    this.$message({
                        message: '文件丢失，请联系管理员！',
                        type: 'error',
                        duration: 1500
                    });
                    return;
                }
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                //标签页方式
                /*window.open("https://view.officeapps.live.com/op/view.aspx?src=" + filePath, "_blank");*/
                //弹出方式
                let fileName = file.split(',');
                //console.log(fileName);
                fileName.forEach((item, index) => {
                    let params = {
                        fileName: item
                    };
                    Upload.getPreviewUrl(params).then(res => {
                        if (res.code === 0) {
                            let preview = res.preview;
                            if (preview.status === 'Finished' || preview.status === 'Timeout') {
                                window.open("https://preview.imm.aliyun.com/index.html?url=" + preview.url + "&copy=1", "_blank", "scrollbars=yes,resizable=1,modal=false,alwaysRaised=yes");
                            } else { //弹出下载提示
                                this.$confirm('文件过大不能预览，是否进行下载?', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(() => {
                                    window.location.href = filePath;
                                }).catch(() => {
                                });
                            }
                        }
                        loading.close();
                    }).catch(res => {
                        loading.close();
                        this.$message({
                            message: '文件丢失，请联系管理员！',
                            type: 'error',
                            duration: 1500
                        });
                        console.log(res)
                    });
                });
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1;
                this.getDataList();
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val;
                this.getDataList();
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val;
            },
            /**
             * 获取数据
             */
            getDataList(type) {
                this.dataListLoading = true;
                if (type === 'search') {
                    this.pageIndex = 1;
                }
                let isType = '';
                if (this.message === 'first') {
                    isType = '家具';
                } else if (this.message === 'second') {
                    isType = '饰品';
                }
                let params = {
                    'pageIndex': this.pageIndex,
                    'limit': this.pageSize,
                    'type': isType,
                    'title': this.dataForm.title,
                    'style': this.dataForm.style
                };
                Means.getMeansList(params).then(res => {
                    if (res.code === 0) {
                        this.dataList = res.page.list;
                        this.totalPage = res.page.totalCount;
                    }
                    this.dataListLoading = false;
                });
            },
            /**
             * 添加或编辑
             * @param id
             */
            addOrUpdateHandle(id) {
                this.addOrUpdateVisible = true;
                this.$nextTick(() => {
                    this.$refs.means.init(id)
                })
            },
            /**
             * 删除
             */
            deleteHandle(id) {
                let ids = id ? id.toString() : this.dataListSelections.map(item => item.id).join();
                //console.log(ids)
                let arrayIds = {'ids': ids};
                this.$confirm('确定删除报价信息吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    Means.deleteMeans(arrayIds).then(res => {
                        if (res.code === 0) {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.$nextTick(() => {
                                        this.getDataList();
                                    })
                                }
                            })
                        }
                    })
                }).catch(() => {
                })
            }
        },
        computed: {}
    }

</script>

<style>
    .message-title {
        cursor: pointer;
    }

    .handle-row {
        margin-top: 30px;
    }

    .el-tag {
        font-size: 13px;
    }

</style>

